import {FormBuilderAnswerableHiddenField, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon} from '@heroicons/react/20/solid'

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableHiddenField<T extends { answerable: FormBuilderAnswerableHiddenField }>({
                                                                                                              question,
                                                                                                              data,
                                                                                                              setData,
                                                                                                              hasError
                                                                                                          }: Props) {

    // check if the default is null and convert it to a string because React doesnt like null
    const value = !data[question.id] ? "" : data[question.id];
    console.log('hidden', value)
    return (
        <div className="relative mt-1">
            <input type={"type" in question.answerable ? question.answerable.type : "text"}
                   className={` rounded shadow-sm block w-full shadow-sm sm:text-sm ${hasError ? 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500' : 'border-gray-100 focus:border-indigo-500 focus:ring-indigo-500 '}`}
                   aria-describedby={`${question.id}-description`}
                   id={`${question.id}-target`}
                   defaultValue={value}
            />
            {(hasError) ? (errorBadge()) : (<></>)}
        </div>
    );

}

function errorBadge() {
    return (<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
    </div>)
}
